import { NgModule } from '@angular/core';
import { ExerciseDiffPage } from 'pages/exercise-diff/exercise-diff-page';
import { ComponentsModule } from 'components/components.module';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [ExerciseDiffPage],
    imports: [PagesModule, ComponentsModule]
})
export class ExerciseDiffPageModule {}
